import { Component, OnInit, Input } from '@angular/core';
import { AssetCardDetails } from 'src/app/models/assetCardDetails';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';
import { ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/modules/userModule/shared/user.service';

@Component({
  selector: 'app-asset-card',
  templateUrl: './asset-card.component.html',
  styleUrls: ['./asset-card.component.css']
})
export class AssetCardComponent implements OnInit {

  @Input()
  asset: AssetCardDetails;
  raters: number = 0;
  assetImage: string;
  relativePath: string;
  routePath: string;
  constructor(private httpService: HttpService, private activatedRoute: ActivatedRoute, private userService: UserService) { }

  ngOnInit() {

    this.activatedRoute.params.subscribe(param => {
      this.relativePath = param.folder;
      this.routePath = "/val-assets/search/assets/" + param.folder + "/" + this.asset._id;
    });
    this.getBUofAsset();
  }

  getBUofAsset() {
    this.httpService.getFolderByRelativePath(this.asset.relativePath.split(',')[0]).subscribe(res => {
      if (res.displayImage != null) {
        this.assetImage = this.asset.imageUrl && this.asset.imageUrl.length > 0 ? 'assets' + '/' + this.asset.imageUrl.split("\\").join("/") : 'assets/DefaultImages/' + res.displayImage.split("\\").join("/");
        if (this.assetImage.includes("http")) {
          this.assetImage = 'assets/DefaultImages/' + res.displayImage.split("\\").join("/");
        }
      }
      else{
        this.assetImage = 'assets/img/CT1.jpg';
      }
    },
      err => {
        console.log(err);
      });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // alert("10")
      for (let i = 0; i < document.getElementsByClassName('image-wrapper').length; i++) {
        alert("10")
        const ele: any = document.getElementsByClassName('image-wrapper')[i];
        ele.style.height = '64%';
      }
    }, 100)

    // const ele2: any = document.getElementsByClassName('cursor-pointer')[0];
    // ele2.style.display = 'none';
  }

  getStars() {
    var rate = this.asset.avgRating;
    this.raters = this.httpService.assetDetails && this.httpService.assetDetails.noOfRatings ? this.httpService.assetDetails.noOfRatings : this.asset.noOfRatings;
    var size = rate / 5 * 100;
    return size + '%';
  }

  checkVisibility(): boolean {
    if (this.asset.visibility == 1 || (this.asset.primaryContactName === this.userService.loggendInUser.name)) {
      return true;
    }
    return false;
  }

}
